// Brand Voice Guide structure
export interface BrandVoiceGuide {
  purpose: string;
  audience: string;
  tone: string;
  emotionalTone: string;
  character: string;
  syntax: string;
  language: string;
  wordsToUse: string[];
  wordsToAvoid: string[];
}

// Content mix percentages (should total 100)
export interface ContentMix {
  education: number;    // Value & Education (default 40%)
  connection: number;   // Connection & Story (default 30%)
  proof: number;        // Proof & Authority (default 20%)
  promotion: number;    // Direct Promotion (default 10%)
}

// Full brand profile
export interface BrandInfo {
  id: string;

  // Basic info (original fields)
  description: string;
  targetAudience: string;
  tone: string;
  keywords: string[];
  sourceUrl?: string;

  // Brand Identity (new fields)
  businessOverview?: string;
  coreIdentity?: string;
  marketPositioning?: string;
  competitors?: string[];
  customerProfile?: string;
  emotionalBenefits?: string;
  brandStory?: string;
  brandPersonality?: string;

  // Products & Services
  productsServices?: string[];
  serviceAreas?: string;

  // Contact
  phoneNumber?: string;

  // Post Topics (manual entry by client)
  postTopics?: string[];

  // Brand Voice Guide
  voiceGuide?: BrandVoiceGuide;

  // Content Mix
  contentMix?: ContentMix;

  // Brand visual identity (from website scan)
  brandColors?: string[];
  brandFonts?: string[];

  createdAt?: string;
}

// Default content mix based on client spec
export const DEFAULT_CONTENT_MIX: ContentMix = {
  education: 40,
  connection: 30,
  proof: 20,
  promotion: 10,
};

export interface BrandAsset {
  id: string;
  name: string;
  url: string;
  type: string;
  isLogo?: boolean;
  createdAt: string;
}

export interface ScrapeRequest {
  url: string;
}

// Content categories for posts
export type ContentCategory = 'education' | 'connection' | 'proof' | 'promotion';

export const CONTENT_CATEGORIES: Record<ContentCategory, { label: string; description: string }> = {
  education: {
    label: 'Value & Education',
    description: 'Educational content, tips, how-tos, and informative posts'
  },
  connection: {
    label: 'Connection & Story',
    description: 'Behind-the-scenes, personal stories, community engagement'
  },
  proof: {
    label: 'Proof & Authority',
    description: 'Testimonials, case studies, certifications, expertise'
  },
  promotion: {
    label: 'Direct Promotion',
    description: 'Service announcements, calls to action, special offers'
  },
};
